import { HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';

/**
 * Origin used to resolve relative `/api` and `/file` calls into absolute URLs
 * while rendering on the server (the browser can use relative URLs, Node cannot).
 * Populated per-request in server.ts from `SSR_API_URL` or the incoming request
 * origin. When it is empty the interceptor leaves the request untouched so the
 * calling code's own error handling renders the default (shell) content instead.
 */
export const SSR_API_ORIGIN = new InjectionToken<string>('SSR_API_ORIGIN');

export const ssrApiInterceptor: HttpInterceptorFn = (req, next) => {
  const origin = inject(SSR_API_ORIGIN, { optional: true });
  if (origin && /^\/(api|file|hub)\b/.test(req.url))
    req = req.clone({ url: origin.replace(/\/$/, '') + req.url });
  return next(req);
};
